"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var IconLabel = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(IconLabel, _React$Component);
  function IconLabel() {
    var _this;
    _classCallCheck(this, IconLabel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, IconLabel, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "processUrl", function (_ref) {
      var url = _ref.url,
        history = _ref.history;
      var found = url.match(/(\/:[\w-]+\?)/g);
      if (found) {
        found.forEach(function (pattern) {
          url = url.replace(pattern, '');
        });
      }
      history.push(url);
    });
    return _this;
  }
  _createClass(IconLabel, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        item = _this$props.item,
        active = _this$props.active;
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: item.handle,
        className: active ? 'active' : ''
      }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        render: function render(_ref2) {
          var history = _ref2.history;
          return /*#__PURE__*/_react["default"].createElement("a", {
            onClick: _this2.processUrl.bind(null, {
              url: item.url,
              history: history
            })
          }, item.render.params.icon && /*#__PURE__*/_react["default"].createElement("span", {
            className: "".concat(_style["default"].icon, " icon")
          }, /*#__PURE__*/_react["default"].createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: item.render.params.icon.viewBox
          }, /*#__PURE__*/_react["default"].createElement("g", null, item.render.params.icon.paths.map(function (p) {
            return /*#__PURE__*/_react["default"].createElement("path", {
              key: p,
              d: p
            });
          })))), /*#__PURE__*/_react["default"].createElement("span", {
            className: "secondary-nav-text"
          }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
            content: item.render.params.label
          })));
        }
      }));
    }
  }]);
  return IconLabel;
}(_react["default"].Component);
_defineProperty(IconLabel, "propTypes", {
  active: _propTypes["default"].bool,
  item: _propTypes["default"].object,
  location: _propTypes["default"].object
});